"use client"

import { t } from "@/languages/i18n"
import { calculateStatus, generateLeafletSlug } from "@/components/leaflet/utils"
import { toImageSrc } from "@/lib/utils"
import { LetakResponseDataObject } from "@/types/codegen/data-contracts"
import Image from "next/image"
import Link from "next/link"

interface LeafletRelatedItemsProps {
    items: LetakResponseDataObject[]
    locale: string
}

export const LeafletRelatedItems = ({ items, locale }: LeafletRelatedItemsProps) => {
    // Keep the current leaflet in the rail to match the production page.
    const filteredItems = items.slice(0, 10)

    if (filteredItems.length === 0) {
        return null
    }

    return (
        <aside className="sm:block hidden w-28 shrink-0 bg-white border-l border-gray-300 overflow-y-auto">
            <div className="py-4 px-2 flex flex-col gap-4">
                <h3 className="text-base leading-5 font-bold uppercase text-[#18AF4E] text-center">{t("You may also like")}</h3>
                <div className="space-y-4">
                    {filteredItems.map((item, index) => (
                        <Link
                            key={item?.id}
                            className="cursor-pointer group relative flex flex-col gap-2 border border-[#00000033] p-1"
                            href={calculateStatus(item.attributes?.dateStart, item.attributes?.dateEnd) === "upcoming"
                                ? "#"
                                : `/${locale}/letak/${generateLeafletSlug(item.attributes?.title || "letak", String(item.id))}`}
                        >
                            <div className="relative w-full h-[93px] overflow-hidden">
                                {item?.attributes?.featuredImage?.data?.attributes?.url && (
                                    <Image
                                        src={toImageSrc(item?.attributes?.featuredImage?.data?.attributes?.url)}
                                        alt={item?.attributes?.title}
                                        fill
                                        className="object-cover w-full h-full transition-transform duration-300 group-hover:scale-105"
                                    />)}
                            </div>
                            <h4 className="text-sm leading-[16.8px] font-bold text-[#000000b3]">
                                {item?.attributes?.title}
                            </h4>
                        </Link>
                    ))}
                </div>
            </div>
        </aside>
    )
}

